import * as actionTypes from './actionTypes';
import { UserModel } from '@app/src/views/Login/login/models/User';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

interface State {
  data: UserModel,
  errorMessage: string,
  isFetching: boolean
}

const initialState: State = {
  data: {
    code: null,
    message: '',
    user: {
      id: Number(decodeAccessToken('idUser')) || null,
      username: decodeAccessToken('username') || '',
      alias: decodeAccessToken('alias') || '',
      isAdmin: Boolean(decodeAccessToken('isAdmin')) || false,
      reportToken: sessionStorage.getItem('reportToken') || '',
      accessToken: sessionStorage.getItem('accessToken') || '',
      service: {
        id: Number(decodeAccessToken('idService')) || null,
        name: decodeAccessToken('service') || '',
        idCountry: Number(decodeAccessToken('idCountry')) || null,
        dateCreated: decodeAccessToken('dateCreated') || ''
      }
    }
  },
  errorMessage: '',
  isFetching: false
};

export const user = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_LOGIN_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false
      };
    case actionTypes.FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        data: action.data,
        isFetching: false
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
}
